import React from "react";
import { setContext } from "apollo-link-context";
import { ApolloLink } from "apollo-link";
import { RetryLink } from "apollo-link-retry";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { onError } from "apollo-link-error";

import { getUserToken } from "./../lib/session";

export default () => {
  const isBrowser = typeof window !== "undefined";

  // Get the authentication token from local storage if it exists
  const authLink = setContext((_, { headers }) => {
    if (isBrowser) {
      const currentToken = getUserToken();
      return {
        headers: {
          ...headers,
          authorization: currentToken ? `Bearer ${currentToken}` : ""
        }
      };
    }
    return {
      headers: { ...headers }
    };
  });

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_APOLLO_CLIENT_URI, // Server URL (must be absolute)
    credentials: "same-origin", // Additional fetch() options like `credentials` or `headers`
    // Use fetch() polyfill on the server
    fetch: !isBrowser && fetch
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.forEach(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        )
      );
    if (networkError) console.log(`[Network error]: ${networkError}`);
  });

  const link = ApolloLink.from([
    new RetryLink(),
    authLink.concat(httpLink),
    errorLink
  ]);

  return new ApolloClient({
    connectToDevTools: isBrowser,
    ssrMode: !isBrowser, // Disables forceFetch on the server (so queries are only run once)
    link,
    cache: new InMemoryCache().restore({})
  });
};
